import Swiper from "swiper";
import { EffectFade, EffectFlip, Navigation, Controller } from "swiper/modules";

// Slider Parameters
const swiperScreens = new Swiper('#slider--screens', {
	modules: [Navigation, Controller],
	slidesPerView: 'auto',
	spaceBetween: 12,
	centeredSlides: true,
	autoHeight: true,
	speed: 200,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
	},
}),
swiperText = new Swiper('#slider--text', {
	modules: [EffectFade],
	effect: 'fade',
	speed: 200,
	fadeEffect: {
		crossFade: true,
	},
	centeredSlides: true,
	slidesPerView: 1,
}),
swiperIcon = new Swiper('#slider--icon', {
	modules: [EffectFlip],
	effect: 'flip',
	speed: 200,
	centeredSlides: true,
	slidesPerView: 1,
});

// Let the screens slider control the other 2
swiperScreens.controller.control = [swiperIcon];
swiperScreens.on('slideChange', () => swiperText.slideTo(swiperScreens.activeIndex));

// Account for the fake last screen slide
swiperScreens.on('activeIndexChange', () => {
	if(swiperScreens.activeIndex == 7) {
		swiperScreens.allowSlideNext = false;
		swiperScreens.isEnd = true;
	} else {
		swiperScreens.allowSlideNext = true;
	}
});

// Change the button behavior on the last slide
swiperScreens.on('slideChangeTransitionEnd', () => {
    const nextButton = document.getElementById('slider-nav-next'),
	      btnClasses = ['swiper-button-disabled', 'btn--icon-only'];

    // console.log(nextButton);

	if (swiperScreens.isEnd) {
		nextButton.disabled = false;
		nextButton.classList.remove(...btnClasses);
		nextButton.classList.add('slider-nav-next--swapped');
		nextButton.setAttribute('role', 'link');
        nextButton.removeAttribute('disabled');
		nextButton.addEventListener('click', addDownloadLink);
	} else {
		nextButton.removeEventListener('click', addDownloadLink);
		nextButton.removeAttribute('role');
		nextButton.classList.remove('slider-nav-next--swapped');
		nextButton.classList.add('btn--icon-only');
	}
});

const addDownloadLink = () => {
	window.location = '/casinoverse-app/download';
};
